'use strict';

require('script!localforage');
localforage.config({
    driver: localforage.LOCALSTORAGE,
    name: 'wg-riddler-localStorage'
});

var _ = require('underscore'),
    $ = require('jquery'),
    AjaxRequest = require('wg-ajaxrequest'),
    Captcha = require('./captcha'),
    POW = require('./pow'),

    ChallengeType = {
        CAPTCHA: 'captcha',
        POW: 'pow'
    },
    Errors = {
        LOCALSTORAGE_NOT_SUPPORTED: 'localstorage_not_supported',
        POW_NOT_SUPPORTED: 'pow_not_supported',
        POW_NOT_SOLVED: 'pow_not_solved'
    },

    defaultOptions = {
        feature: null,
        url: null,

        resolved: function() {},

        preferredChallengeType: ChallengeType.POW,
        fallbackChallengeType: ChallengeType.CAPTCHA,
        challengeLifetime: 10 * 60,  // seconds
        challengeBanTimeout: 1,  // seconds

        powEvalPath: null,
        powSHA3Path: null,

        loggingEnabled: false,
        debugEnabled: false,
        syncStorageEnabled: false
    },

    // localStorage keys
    challengeKey = 'challenge',
    resultsKey = 'results',
    expiresAtKey = 'expiresAt';

function iedetect() {
    var ua = window.navigator.userAgent,
        msie = ua.indexOf('MSIE '),
        trident = ua.indexOf('Trident/'),
        edge = ua.indexOf('Edge/'),
        rv = ua.indexOf('rv:');

    if (msie > 0) {
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    if (trident > 0) {
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    if (edge > 0) {
       return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    return false;
}

function Riddler(options) {
    if (!_.isObject(options)) {
        options = {};
    }

    _.defaults(options, defaultOptions);

    options.syncStorageEnabled = !iedetect() && options.syncStorageEnabled;

    this.options = options;

    if (!this.options.loggingEnabled) {
        this.log = function() {};
    }

    this.challengeType = this.options.preferredChallengeType;
    if (!Riddler.proofOfWorkSupported()) {
        this.log(Errors.POW_NOT_SUPPORTED, {
            localStorageSupported: Riddler.localStorageSupported(),
            webWorkersSupported: Riddler.webWorkersSupported()
        });
        this.challengeType = this.options.fallbackChallengeType;
    }
    if (this.options.syncStorageEnabled) {
        $(window).on('storage', _.bind(this.onStorageKeyUpdate, this));
    }
}

Riddler.ChallengeType = ChallengeType;
Riddler.Errors = Errors;

Riddler.localStorageSupported = function() {
    return localforage.supports(localforage.LOCALSTORAGE);
};

Riddler.webWorkersSupported = function() {
    return POW.isSupported();
};

Riddler.proofOfWorkSupported = function() {
    return Riddler.localStorageSupported() && Riddler.webWorkersSupported();
};

Riddler.prototype = {
    onStorageKeyUpdate: function(event) {
        var isResultKey = event.originalEvent.key.indexOf(this.getLocalStorageKey(resultsKey)) > -1,
            newValueIsDefined = !_.isUndefined(event.originalEvent.newValue);

        if (isResultKey && newValueIsDefined) {
            localforage.getItem(this.getLocalStorageKey(resultsKey), _.bind(function(error, results) {
                if (!error && results) {
                    this.resolved(results);
                    return;
                }
            }, this));
        }
    },
    solve: function() {
        if (Riddler.localStorageSupported()) {
            this.retrieveChallengeFromLocalStorage();
        } else {
            this.retrieveChallengeFromBackend();
        }
    },
    update: function(challengeType) {
        if (challengeType) {
            this.challengeType = challengeType;
        }
        this.retrieveChallengeFromBackend();
    },
    clear: function() {
        localforage.removeItem(this.getLocalStorageKey(challengeKey));
        localforage.removeItem(this.getLocalStorageKey(resultsKey));
        localforage.removeItem(this.getLocalStorageKey(expiresAtKey));
    },
    log: function(message, tags) {
        tags = tags || {};
        Raven.captureMessage(message, {tags: tags});
    },
    retrieveChallengeFromLocalStorage: function() {
        localforage.getItem(this.getLocalStorageKey(expiresAtKey), _.bind(function(error, expiresAt) {
            if (error || !expiresAt) {
                this.retrieveChallengeFromBackend();
                return;
            }

            if (this.checkIsExpired(expiresAt)) {
                this.retrieveChallengeFromBackend();
                return;
            }

            localforage.getItem(this.getLocalStorageKey(resultsKey), _.bind(function(error, results) {
                if (!error && _.isObject(results)) {
                    this.resolved(results);
                    return;
                }

                localforage.getItem(this.getLocalStorageKey(challengeKey), _.bind(function(error, challenge) {
                    if (error || !_.isObject(challenge)) {
                        this.retrieveChallengeFromBackend();
                        return;
                    }

                    this.solveChallenge(challenge);
                }, this));
            }, this));
        }, this));
    },
    retrieveChallengeFromBackend: function() {
        var queryParams;

        this.clear();
        queryParams = {
            type: this.challengeType
        };

        if (this.options.debugEnabled) {
            queryParams.reduce_riddler_complexity = this.options.debugEnabled;
        }
        AjaxRequest.submit(queryParams, {
            url: this.options.url,
            method: 'GET',
            success: _.bind(function(data) {
                var expiresAt = new Date().getTime() / 1000 + this.options.challengeLifetime;

                localforage.setItem(this.getLocalStorageKey(expiresAtKey), expiresAt);
                localforage.setItem(this.getLocalStorageKey(challengeKey), data);

                this.solveChallenge(data);
            }, this),
            error: _.bind(function() {
                setTimeout(
                    _.bind(this.retrieveChallengeFromBackend, this),
                    this.options.challengeBanTimeout * 1000
                );
            }, this)
        });
    },
    solveChallenge: function(challenge) {
        var defaultOptions = {
                resolved: _.bind(this.resolved, this)
            },
            options;

        this.challengeType = _.values(challenge)[0].type;

        if (this.challengeType === ChallengeType.CAPTCHA) {
            options = _.extend({}, defaultOptions);
            new Captcha(options).solve(challenge);
        } else if (this.challengeType === ChallengeType.POW) {
            options = _.extend({
                evalPath: this.options.powEvalPath,
                sha3Path: this.options.powSHA3Path
            }, defaultOptions);
            new POW(options).solve(challenge);
        }
    },

    resolved: function(results) {
        if (results.type === ChallengeType.POW && !results.results) {
            this.log(Errors.POW_NOT_SOLVED);
        }
        localforage.setItem(this.getLocalStorageKey(resultsKey), results);
        this.options.resolved(results);
    },

    getResults: function(cb) {
        if (!Riddler.localStorageSupported()) {
            cb(Errors.LOCALSTORAGE_NOT_SUPPORTED);
            return;
        }

        localforage.getItem(this.getLocalStorageKey(resultsKey), function(error, result) {
            if (error) {
                cb(Errors.LOCALSTORAGE_NOT_SUPPORTED);
                return;
            }

            cb(null, result);
        });
    },
    checkIsExpired: function(expiresAt) {
        var now = new Date().getTime() / 1000;

        return expiresAt < now;
    },
    getLocalStorageKey: function(key) {
        return this.options.feature + ':' + key;
    }
};

module.exports = Riddler;



/*****************
 ** WEBPACK FOOTER
 ** ./lib/riddler.js
 ** module id = 0
 ** module chunks = 0
 **/